import { Component, EventEmitter, Input, Output } from '@angular/core';

export type AlertTone = 'info' | 'warning' | 'critical';

const ALERT_TONE_ICON: Record<AlertTone, string> = {
  info: 'assets/icons/new/info-circle.svg',
  warning: 'assets/icons/new/warning.svg',
  critical: 'assets/icons/alert.svg',
};

@Component({
  selector: 'fi-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
})
export class AlertComponent {
  @Input() tone: AlertTone = 'info';
  @Input() actionLabel?: string;
  @Input() actionIcon?: string;
  @Input() dismissible = false;

  get icon(): string {
    return ALERT_TONE_ICON[this.tone];
  }

  @Output() action = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();
}
